<template>
  <label class="font-medium text-gray-700">
    <span v-if="value">{{ value }}</span>
    <span v-else><slot></slot></span>
  </label>
</template>

<script>
export default {
  props: ['value'],
};
</script>
